// src/Components/MenuCards/MenuCard.jsx

import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

export default function MenuCard(props) {
  return (
    <Card
      sx={{
        maxWidth: '333px !important',
        width: '100%',
        background: '#283341',
        borderRadius: '0px',
        margin: '5px 2px !important',
        height: '100%',
      }}
    >
      <CardActionArea
        onClick={props.onAddToCart}
        sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
      >
        {/* 4:3 aspect‑ratio box */}
        <Box
          sx={{
            width: '100%',
            pb: '75%',           // 3/4 = 75%
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <CardMedia
            component="img"
            image={props.img}
            alt={props.title}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
          {props.badge && (
            <Chip
              label={props.badge}
              size="small"
              sx={{
                position: 'absolute',
                bottom: 10,
                right: 10,
                backgroundColor: props.badgeBackground || '#e0af4a',
                color: '#fff',
                fontWeight: 700,
                fontSize: '11px',
                height: '22px',
                borderRadius: '4px',
              }}
            />
          )}
        </Box>

        <CardContent
          sx={{
            padding: '10px 20px',
            textAlign: { xs: 'center', md: 'left' },
            backgroundColor: props.contentBackground,
            flexGrow: 1,
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{
              fontSize: { xs: '16px', md: '13px' },
              fontWeight: '700',
              margin: '10px 0px',
              color: '#fff',
              textTransform: 'uppercase',
              lineHeight: '1.7em',
            }}
          >
            {props.title}
          </Typography>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{
              fontSize: { xs: '14px', md: '13px' },
              fontWeight: '700',
              textTransform: 'uppercase',
              color: props.contentSecondaryColor || '#e0af4a',
              lineHeight: '1.7em',
            }}
          >
            {props.subTitle}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
